import { AvoraLogo } from "@/components/AvoraLogo";

export default function AuthShell({ children }) {
  return (
    <div className="min-h-screen flex bg-[#F6F4EE]">
      <div className="hidden lg:flex w-[46%] bg-[#0D2B45] text-slate-100 flex-col justify-between p-16 relative overflow-hidden">
        <AvoraLogo dark size="lg" sub="Intelligence Reporting Platform" />
        <div className="fade-up">
          <p className="small-label !text-amber-400">Asset Visualization Ownership Reporting Application</p>
          <div className="h-0.5 w-16 bg-amber-500 mt-5" />
          <h1 className="font-serif text-5xl xl:text-6xl leading-[1.05] tracking-tight mt-6">
            Every entity.<br />Every percentage.<br /><span className="text-amber-500">One statement.</span>
          </h1>
          <p className="text-slate-400 mt-8 max-w-md leading-relaxed">
            Upload accounting, brokerage, investment, land and oil &amp; gas balances. AVORAlogic rolls ownership
            through every partnership, trust and LLC to produce entity valuations and individual net worth statements.
          </p>
        </div>
        <div className="font-mono text-[11px] text-slate-400 tracking-widest uppercase">Internal use · Confidential</div>
        <div className="absolute -right-32 -bottom-32 h-96 w-96 border border-white/5 rounded-full" />
        <div className="absolute -right-12 -bottom-12 h-56 w-56 border border-white/5 rounded-full" />
      </div>
      <div className="flex-1 flex items-center justify-center p-6">{children}</div>
    </div>
  );
}
